var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.6519C13.723 13.6519 15.1199 12.2551 15.1199 10.5319C15.1199 8.8088 13.723 7.41193 11.9999 7.41193C10.2768 7.41193 8.87988 8.8088 8.87988 10.5319C8.87988 12.2551 10.2768 13.6519 11.9999 13.6519Z",
    stroke: "#D6D6D6",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61971 8.71193C5.58971 0.0519261 18.4197 0.0619264 20.3797 8.72193C21.5297 13.8019 18.3697 18.1019 15.5997 20.7619C13.5897 22.7019 10.4097 22.7019 8.38971 20.7619C5.62971 18.1019 2.46971 13.7919 3.61971 8.71193Z",
    stroke: "#D6D6D6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cb5a5894cfb4661c413cfe1bff64bab3.svg";
export { ForwardRef as ReactComponent };